import PageModule from "@eisinc/Overrides/Pages/RfqQuoteDetailsPage";

export * from "@eisinc/Overrides/Pages/RfqQuoteDetailsPage";

export default PageModule;
